export enum InvoicesFilter {
    Open = "OPEN",
    Paid = "PAID"
  }
  